import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    flagContainer: hasError => ({
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 8,
      borderWidth: hasError ? 2 : 1,
      borderRadius: 16,
      borderColor: hasError ? colors.danger : colors.borderMuted,
      marginRight: 8,
    }),
    inputTitleStyle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 16,
      lineHeight: 24,
      color: colors.textMuted,
      marginBottom: 8,
    },
    errorText: {
      color: colors.danger,
      fontFamily: FONTS.regularFont,
      fontSize: 14,
      lineHeight: 21,
      marginTop: 8,
    },
    marginBottom12: {
      marginBottom: 12,
    },
    flex1: {
      flex: 1,
    },
    flex1Width292: {
      flex: 1,
      maxWidth: 292,
    },
  });

export default makeStyles;
